import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectDocumentArrayModel, ProjectDocumentModel } from "../../models/ProjectDocumentModel";

const initialProjectDocumentState: ProjectDocumentArrayModel = {
    particular_ProjectDocuments: []
}
const ProjectDocumentSlice = createSlice({
    name: 'ProjectDocument',
    initialState: initialProjectDocumentState,
    reducers: {
        setParticularProjectDocuments(state, action: PayloadAction<ProjectDocumentModel[]>) {
            state.particular_ProjectDocuments = action.payload;
        }
    }
})
export default ProjectDocumentSlice;